import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ontruck/orc';
import LoadSpinner from 'components/LoadSpinner';

const PaginationButton = ({
  className,
  hasMorePages,
  fetchMore,
  isFetching,
  label,
}) => (
  <div className={className}>
    {hasMorePages && (
      <Button
        onClick={fetchMore}
        text={isFetching ? <LoadSpinner skin="inButtonGrey" /> : label}
        skin="secondary"
        ghost
      />
    )}
  </div>
);

PaginationButton.propTypes = {
  className: PropTypes.string,
  hasMorePages: PropTypes.bool,
  fetchMore: PropTypes.func,
  isFetching: PropTypes.bool,
  label: PropTypes.string,
};

PaginationButton.defaultProps = {
  className: '',
  hasMorePages: false,
  fetchMore: () => ({}),
  isFetching: false,
  label: '',
};

export default PaginationButton;
